<template>
    <div class="container-fluid" style="margin-bottom: -20px; background: url('https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bg.jpg'); background-size: cover;">
        <div class="row">
            <div class="col s12 long-jpeg-container">
                <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-frame.png">
                <div class="row">
                    <div class="col s12 logo-col">
                        <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/TEFAL_Logo.png">
                    </div>
                </div>
            </div>
        </div>

        <div class="container title-cont">
            <div class="row">
                <div class="col s12">
                    <img class="responsive-img title-gif" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/title.gif">
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <h1 class="title">3 langkah mudah untuk menebus hadiah dan <br class="hide-on-small-only"> berkongsi berkat sempena Hari Raya yang mulia ini</h1>
                </div>
            </div>
            <div class="row">
                <div class="col s12 m4">
                    <img class="responsive-img langkah-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/Beli.png">
                    <div class="langkah-title">Langkah 1</div>
                    <div class="langkah-description">Beli mana-mana produk Tefal<br> dan daftar <a :href="warrantyUrl">e-Warranty</a> semasa tempoh kempen</div>
                </div>
                <div class="col s12 m4">
                    <img class="responsive-img langkah-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/Kumpul.png">
                    <div class="langkah-title">Langkah 2</div>
                    <div class="langkah-description">Satu (1) keping stiker akan diberikan bagi setiap RM100 yang dibelanjakan</div>
                </div>
                <div class="col s12 m4">
                    <img class="responsive-img langkah-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/Tebus_Derma.png">
                    <div class="langkah-title">Langkah 3</div>
                    <div class="langkah-description">Kumpul stiker Tefal untuk menebus hadiah atau menderma nilai stiker kepada golongan yang memerlukan</div>
                </div>
            </div>


            <div class="row">
                <div class="col s12">
                    <h1 class="title" style="text-transform: uppercase">Semak jumlah stiker anda di bawah dan mulakan penebusan hadiah anda sekarang atau dermakan nilai stiker anda ke dalam peti sumbangan tefal!</h1>
                </div>
                <div class="col s12 center-align sticker-total-cont">
                    <div class="stiker-total-title">Jumlah stiker terkumpul: {{ stickers }}</div>
                </div>
                <div class="col s12 center-align">
                    <h1 class="title">Saya ingin_____.</h1>
                </div>
            </div>
            <div class="row derma-main-row">
                <div class="col s12">
                    <div class="derma-cont">
                        <div class="row">
                            <div class="col s12 m6">
                                <a href="#products"><img class="responsive-img" style="cursor: pointer; width: 100%" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/Tebus_action.png"></a>
                            </div>
                            <div class="col s12 m6">
                                <img v-on:click="openDonate" style="cursor: pointer; width: 100%" class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/Derma_action.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" id="products">
                <div class="col s12 product-col">
                    <img class="responsive-img" style="position: absolute; left: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-left-frame.png">
                    <img class="responsive-img" style="position: absolute; right: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-right-frame.png">
                    <img class="responsive-img" style="position: absolute; left: 0; bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-left-frame.png">
                    <img class="responsive-img" style="position: absolute; right: 0;  bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-right-frame.png">
                    <div class="row" style="margin-bottom: 0">
                        <div class="col s12 product-inner-col center-align">
                            <!--<div class="row" v-if="products.length > 0">
                                <div class="col s6 m4 l3" v-for="(product, index) in products" v-on:click="selectPrize(product)">
                                    <div class="product-img-cont">
                                        <img class="responsive-img product-img" :src="product.inactive_img" v-if="stickers < product.sticker_need">
                                        <img class="responsive-img product-img" :src="product.active_img" v-else>
                                    </div>
                                    <div class="product-sticker">{{ product.sticker_need }} stiker</div>
                                    <div class="product-name">{{ product.name }}</div>
                                    <span style="cursor: pointer">
                                        <div class="tebus-btn" v-if="stickers < product.sticker_need"><img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/products/TEBUS_BW.png"></div>
                                        <span v-else>
                                             <div class="tebus-btn" v-if="!product.is_submit_again"><img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/products/TEBUS_Red.png"></div>
                                                <div class="tebus-btn" v-else><img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/TEBUS-Lagi.png"></div>
                                        </span>
                                    </span>
                                </div>
                            </div>-->
                            <h1 class="title" style="text-transform: uppercase">Kempen sudah tamat</h1>
                            <div class="row">
                                <div class="col s12 center-align">
                                    <a href="#" class="semak-hadiah" v-if="redeem_lists.length > 0" v-on:click.prevent="openRedeemModal">Semak hadiah yang telah ditebus</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col s12 center-align">
                    <span class="term-title">*Tertakluk kepada <a href="#" v-on:click.prevent="openTermaModal">terma and syarat</a>. Sementara stok masih ada.</span>
                </div>
            </div>

            <div class="row promosi-main-row">
                <div class="col s12">
                    <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/promosi-title.png">
                </div>
            </div>

            <div class="row">
                <div class="col s12">
                    <p class="promosi-title">
                        Hadiah percuma dengan setiap pembelian peralatan memasak terpilih Tefal dari <br>
                        <span>1 APR - 31 MEI 2022</span>
                    </p>
                </div>
            </div>
            <div class="row">
                <div clas="co s12">
                    <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/Gifts.png">
                </div>
            </div>
        </div>

        <div id="redeem-modal" class="modal">
            <a href="#!" class="modal-close" v-on:click="closeModal" style="position: absolute; top: 2%; right: 1%; color: #000; z-index: 1;"><i class="material-icons close-btn">close</i></a>
            <img class="responsive-img" style="position: absolute; left: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-right-frame.png">
            <img class="responsive-img" style="position: absolute; left: 0; bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;  bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-right-frame.png">
            <div class="modal-content">
                <div class="row">
                    <div class="col s12">
                        <img class="responsive-img" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/subtitle.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col s12 redeem-inner-col">
                        <div class="row" v-if="redeem_lists.length > 0" v-for="(redeem, index) in redeem_lists">
                            <div class="col s2">
                                {{ index+1 }}
                            </div>
                            <div class="col s4">
                                {{ redeem.product.name }}
                            </div>
                            <div class="col s3">
                                {{ redeem.name }}
                            </div>
                            <div class="col s3">
                                {{ redeem.censor_phone_no }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Structure -->
        <div id="select-prize-modal" class="modal">
            <a href="#!" class="modal-close" v-on:click="closeModal" style="position: absolute; top: 2%; right: 1%; color: #000; z-index: 1;"><i class="material-icons close-btn">close</i></a>
            <img class="responsive-img" style="position: absolute; left: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-right-frame.png">
            <img class="responsive-img" style="position: absolute; left: 0; bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;  bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-right-frame.png">

            <div class="modal-content" v-if="userId > 0">
                <div class="row" v-if="!is_success_submit">
                    <div class="col s12">
                        <input class="form-control" style="display:block !important;" placeholder="Nama" v-model="name" readonly>
                    </div>
                    <div class="col s12">
                        <input class="form-control" style="display:block !important;" placeholder="Emel" v-model="email" readonly>
                    </div>
                    <div class="col s12">
                        <input class="form-control" style="display:block !important;" placeholder="Nombor Telefon" v-model="phone_no" readonly>
                    </div>
                    <div class="col s12">
                        <textarea class="form-control" rows="5" placeholder="Alamat Penghantaran" v-model="address"></textarea>
                    </div>
                    <div class="col s12">
                        <img class="responsive-img modal-img" :src="chosen_product.active_img" style="display: block !important;">
                        <div class="product-name center-align">{{ chosen_product.name }}</div>
                    </div>
                    <div class="col s12 penghantaran-col">
                        <div class="penghantaran-title">Tempoh Penghantaran: 4 - 6 minggu</div>
                    </div>
                    <div class="col s12">
                        <p>
                            <label>
                                <input type="checkbox" class="filled-in" v-model="is_agree_term" />
                                <span>Saya mengesahkan bahawa maklumat yang telah saya berikan adalah tepat dan benar. Saya juga faham bahawa sebarang penipuan dan ketidakjujuran boleh mengakibatkan pembatalan hak penyertaan. Saya telah membaca dan bersetuju dengan <a href="#" v-on:click.prevent="openTermaModal">terma and syarat</a> serta dasar privasi Tefal.</span>
                            </label>
                        </p>
                    </div>
                    <div class="col s12 center-align" v-if="is_allow_submit">
                        <a class="waves-effect waves-light btn action-btn" v-if="!is_loading" v-on:click="submitData(chosen_product)">Hantar</a>
                        <a class="btn disabled action-btn" v-if="is_loading">Hantar</a>
                    </div>
                </div>
                <div class="row" v-if="is_success_submit">

                    <div class="col s12 center-align">
                        <div class="modal-message">
                            <span>Terima kasih kerana menyertai kempen Berkat Raya Bersama! Ikuti laman Facebook rasmi <a href="https://www.facebook.com/mytefal">Tefal Malaysia</a> untuk perkembangan terkini dan</span>
                            <a href="https://www.facebook.com/sharer/sharer.php?u=https://clubtefal.com.my/raya2022">kongsikan</a>
                            <span>amalan mulia dengan rakan dan ahli keluarga.</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-content" v-else>
                <div class="row">
                    <div class="col s12 center-align">
                        <p class="modal-message">Sila log masuk untuk menyertai kempen.</p>
                        <a class="waves-effect waves-light btn action-btn" :href="warrantyUrl">Log Masuk</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Structure -->
        <div id="error-modal" class="modal">
            <a href="#!" class="modal-close" v-on:click="closeModal" style="position: absolute; top: 2%; right: 1%; color: #000; z-index: 1;"><i class="material-icons close-btn">close</i></a>
            <img class="responsive-img" style="position: absolute; left: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-right-frame.png">
            <img class="responsive-img" style="position: absolute; left: 0; bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;  bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-right-frame.png">

            <div class="modal-content">
                <div class="row">
                    <div class="col s12 center-align">
                        <p class="modal-message">Stiker anda tidak mencukupi untuk menebus hadiah ini.</p>
                    </div>
                </div>

            </div>
        </div>

        <!-- Modal Structure -->
        <div id="donate-modal" class="modal">
            <a href="#!" class="modal-close" v-on:click="closeModal" style="position: absolute; top: 2%; right: 1%; color: #000; z-index: 1;"><i class="material-icons close-btn">close</i></a>
            <img class="responsive-img" style="position: absolute; left: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/top-right-frame.png">
            <img class="responsive-img" style="position: absolute; left: 0; bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-left-frame.png">
            <img class="responsive-img" style="position: absolute; right: 0;  bottom: 0;" src="https://tefalclub-products.s3.ap-southeast-1.amazonaws.com/raya2022/bottom-right-frame.png">

            <div class="modal-content" v-if="userId > 0">
                <div class="row" v-if="!is_success_donate">
                    <div class="col s12">
                        <input class="form-control number-donate-input" type="number" placeholder="Nombor stiker" v-model="donate_stickers">
                        <div class="up-down" style=" display: inline-block;">
                            <div class="arrow-col" v-on:click.prevent="incrementSticker">
                                <i class="material-icons">keyboard_arrow_up</i>
                            </div>
                            <div class="arrow-col" v-on:click.prevent="decrementSticker">
                                <i class="material-icons">keyboard_arrow_down</i>
                            </div>
                        </div>
                    </div>
                    <div class="col s12">
                        <p>
                            <label>
                                <input type="checkbox" class="filled-in" v-model="is_agree_donate" />
                                <span>Saya bersetuju dan mengesahkan bahawa saya ingin menderma {{ donate_stickers }} stiker kepada peti sumbangan pusat Tefal. Saya juga mengesahkan bahawa saya telah membaca dan bersetuju dengan <a href="#" v-on:click.prevent="openTermaModal">terma and syarat</a> serta dasar privasi Tefal.</span>
                            </label>
                        </p>
                    </div>
                    <div class="col s12 center-align" v-if="is_allow_donate">
                        <a class="waves-effect waves-light btn action-btn" v-if="!is_loading" v-on:click="submitDonate">Derma</a>
                        <a class="btn disabled action-btn" v-if="is_loading">Derma</a>
                    </div>
                </div>

                <div class="row" v-if="is_success_donate">
                    <div class="col s12 center-align">
                        <p class="modal-message">Terima kasih kerana menyertai kempen Berkat Raya Bersama! Ikuti laman Facebook rasmi <a href="https://www.facebook.com/mytefal">Tefal Malaysia</a> untuk perkembangan terkini dan <a href="#">kongsikan</a> amalan mulia dengan rakan dan ahli keluarga.</p>
                    </div>
                </div>
            </div>

            <div class="modal-content" v-else>
                <div class="row">
                    <div class="col s12 center-align">
                        <p class="modal-message">Sila log masuk untuk menyertai kempen.</p>
                        <a class="waves-effect waves-light btn action-btn" :href="warrantyUrl">Log Masuk</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Structure -->
        <div id="terma-modal" class="modal">
            <a href="#!" class="modal-close" style="position: absolute; top: 2%; right: 1%; color: #000; z-index: 1;"><i class="material-icons close-btn">close</i></a>
            <div class="modal-content">
                <div class="row">
                    <div class="col s12">
                        <h1 class="terma-title">Kaedah Penyertaan</h1>

                        <h3 class="terma-subtitle">Siapakah yang Boleh Menyertai Peraduan?</h3>
                        <p>Kempen ini terbuka kepada semua pelanggan yang berkelayakan dan telah mendaftar e-Waranti Tefal melalui portal Kelab Tefal dan telah diluluskan dari 1 APRIL – 31 MEI 2022.</p>
                        <br>
                        <h3 class="terma-subtitle">Siapakah yang Layak Untuk Menyertai?</h3>
                        <p>Semua pelanggan yang bermastautin di Malaysia dengan alamat Malaysia yang sah dan telah membeli produk Tefal daripada Groupe SEB Malaysia Sdn. Bhd. atau pengedar sahnya di Malaysia ketika tempoh kempen.</p>
                        <br>
                        <h3 class="terma-subtitle">Siapakah yang Tidak Layak Untuk Menyertai?</h3>
                        <p>Pekerja Groupe SEB Malaysia Sdn. Bhd. (termasuk syarikat yang bersekutu dan berkaitan dengan Groupe SEB Malaysia Sdn. Bhd.), ahli keluarga mereka yang terdekat (termasuk anak, ibu bapa, adik beradik lelaki dan perempuan, atau pasangan suami isteri), wakil, pekerja, kakitangan dan/atau ejen pengiklanan, dan/atau pembekal perkhidmatan promosi, dan/atau penjual semula, pengedar, pengedar Groupe SEB Malaysia Sdn. Bhd. (termasuk syarikat yang bersekutu dan berkaitan dengan Groupe SEB Malaysia Sdn. Bhd.), dan ahli keluarga mereka yang terdekat (termasuk anak, ibu bapa, adik beradik lelaki dan perempuan, serta pasangan suami isteri.</p>
                        <br>
                        <h3 class="terma-subtitle">Bagaimanakah Cara Untuk Menyertai?</h3>
                        <p>Sila ikut semua langkah di bawah tentang cara untuk menyertai kempen serta cara menuntut barangan hadiah ketika tempoh kempen</p>
                        <ul class="browser-default">
                            <li>Beli mana-mana produk Tefal ketika tempoh kempen.</li>
                            <li>Simpan bukti pembelian anda.</li>
                            <li>Sila ke halaman web <a href="https://clubtefal.com.my">https://clubtefal.com.my/</a></li>
                            <li>Log masuk ke akaun anda yang telah sedia ada / Daftar akaun baharu.</li>
                            <li>Daftar dan serahkan e-Waranti BAHARU anda.</li>
                            <li>Kelulusan dan proses kemas kini pentadbir akan mengambil masa antara 3-5 hari, dan boleh disemak pada halaman ‘View Warranty’ di <a href="https://clubtefal.com.my">https://clubtefal.com.my/</a></li>
                            <li>Sila ke tab kempen bertajuk “Raya 2022” untuk dibawa semula ke halaman kempen setelah e-Waranti anda berjaya diluluskan. Anda hanya akan dimaklumkan tentang e-Waranti yang diluluskan ketika tempoh kempen.</li>
                            <li>Semak pelekat yang diberikan.</li>
                            <li>Kumpul pelekat untuk menebus barangan hadiah yang dikehendaki.</li>
                            <li>Nombor daripada pelekat akan digunakan bagi setiap penebusan dan kaunter pelekat akan ditetapkan semula kepada 0.</li>
                            <li>Anda juga boleh memilih untuk menderma pelekat yang telah sedia ada kepada badan amal yang telah dilantik.</li>
                            <li>E-mel penghargaan akan dihantar selepas pengesahan berjaya dilakukan untuk barangan hadiah yang ditebus dan penyerahan butiran peribadi anda.</li>
                            <li>Barangan hadiah anda akan dihantar dalam tempoh  4-6 minggu selepas e-mel penghargaan dihantar.</li>
                        </ul>

                        <p style="font-style: italic">*Semua penyerahan e-Waranti mestilah baharu dan tidak pernah dihantar sebelum ini. Semua penyerahan yang dibuat sebelum dan/atau selepas tempoh kempen tidak akan diambil kira sebagai penyerahan yang sah.</p>
                        <p style="font-style: italic">*Setiap barangan hadiah adalah tertakluk kepada had kuantitinya.</p>
                        <p style="font-style: italic">*Penebusan adalah berdasarkan ‘siapa cepat dia dapat. Sementara stok masih ada’.</p>
                        <p style="font-style: italic">*RM 100 dalam setiap nilai RRP bagi produk yang dibeli = 1 pelekat.</p>
                        <p style="font-style: italic">*Tefal akan mengumumkan jumlah koleksi pelekat, jumlah nilai yang telah ditukar ke dalam bentuk wang tunai dan/atau produk, jumlah nilai barangan jenama kolaborasi yang akan didermakan kepada badan amal yang telah dilantik.</p>

                        <h1 class="terma-title">Terma & Syarat</h1>
                        <ul class="browser-default">
                            <li>Kempen ini dianjurkan oleh Groupe SEB Malaysia Sdn. Bhd. dan akan berlangsung dari 1 APR hingga 31 MEI 2022 (termasuk kedua-dua tarikh) ("Tempoh Kempen").</li>
                            <li>Semua keputusan yang dibuat berkaitan kempen termasuklah keputusan untuk menentukan pemenang dan hadiah merupakan budi bicara mutlak pihak Groupe SEB Malaysia Sdn. Bhd. dan sebarang urusan surat-menyurat, percubaan atau permohonan rayuan, menyemak atau mempertikai keputusan tersebut tidak akan dilayan.</li>
                            <li>Produk yang diberikan oleh Groupe SEB Malaysia Sdn. Bhd. tidak boleh dipindah milik kepada mana-mana pihak ketiga dan tidak boleh ditukar kepada bentuk wang tunai dan/atau rawatan dan perkhidmatan lain.</li>
                            <li>Proses lengkap hadiah yang diberikan TIDAK BOLEH dibatalkan, ditamatkan, dikembalikan atau ditukar atas apa-apa sebab sekalipun.</li>
                            <li>Groupe SEB Malaysia Sdn. Bhd. tidak memberi jaminan terhadap kualiti barangan atau kesesuaiannya untuk sebarang tujuan.</li>
                            <li>Sila beri tempoh masa 4-6 minggu untuk proses penghantaran barangan hadiah daripada pengeposan e-mel penghargaan.</li>
                            <li>Tiada penghantaran yang akan dibuat ke alamat Kotak P.O. dan juga alamat di luar Malaysia.</li>
                            <li>Jika ahli tidak menerima barangan hadiah selepas empat belas (14) hari perniagaan dari tarikh pemberitahuan penghantaran, ahli perlu bertanggungjawab untuk memaklumkan Groupe SEB Malaysia Sdn. Bhd. tentang ketidakterimaan barangan hadiah. Sekiranya tiada pertanyaan diterima pada hari perniagaan kelapan belas (hari ke 18) dari tarikh pemberitahuan penghantaran, barangan hadiah akan dianggap sebagai telah diterima dan ia diterima dalam keadaan baik oleh ahli.</li>
                            <li>Semua hadiah mesti dituntut dalam tempoh masa yang ditetapkan seperti yang dinyatakan dalam Terma & Syarat kempen bernombor 21. Mana-mana hadiah yang tidak dituntut akan dibatalkan dan Groupe SEB Malaysia Sdn. Bhd. tidak akan membayar pampasan atau bertanggungjawab atas kegagalan untuk menuntut hadiah. Sebarang rayuan tidak akan dilayan. Sebarang penyertaan yang dihantar selepas tarikh tutup kempen tidak akan dilayan.</li>
                            <li>Jika pilihan barangan hadiah tidak tersedia atas sebab barangan hadiah telah kehabisan stok buat sementara waktu atau dihentikan, Groupe SEB Malaysia Sdn. Bhd. berhak untuk menggantikan hadiah dengan barangan lain yang sama nilainya selepas memaklumkannya kepada ahli.</li>
                            <li>Dengan menyertai kempen ini, peserta dianggap telah membaca, memahami, dan bersetuju untuk terikat dengan Terma dan Syarat yang dinyatakan di sini. Para peserta dengan ini membenarkan dan bersetuju untuk menggunakan nama dan/atau gambar yang diambil oleh dan oleh peserta oleh Penganjur sebagai bahan untuk tujuan pengiklanan, perdagangan dan/atau publisiti tanpa notis terlebih dahulu kepada peserta dan peserta tidak berhak menuntut hak milik dan/atau bentuk pampasan lain.</li>
                            <li>Sebarang keputusan yang dibuat oleh Groupe SEB Malaysia Sdn. Bhd. adalah muktamad dan terikat dan sebarang urusan surat-menyurat dalam bentuk lisan atau bertulis tidak akan dilayan.</li>
                            <li>Groupe SEB Malaysia Sdn. Bhd. Berhak untuk menambah, memadam, atau meminda Terma & Syarat di sini atau mengubah atau mengubah suai mana-mana aspek kempen ini secara keseluruhan atau sebahagiannya pada bila-bila masa dan dari semasa ke semasa serta mengikut budi bicara mutlak tanpa notis dan tanpa liabiliti kepada mana-mana peserta atau mana-mana pihak lain.</li>
                            <li>Kempen ini sama sekali tidak ditaja, disokong, atau ditadbir atau dikaitkan dengan mana-mana rangkaian sosial, enjin carian dan sebagainya. Peserta memberikan maklumat terus kepada Groupe SEB Malaysia Sdn. Bhd. dan bukan kepada mana-mana pihak lain.</li>
                            <li>Para Peserta yang menyertai kempen ini dengan ini bersetuju dengan terma dan syarat Notis Privasi Penganjur yang disenaraikan di https://www.tefal.com.my/privacy yang termasuk dan tidak terhad kepada persetujuan peserta untuk memproses, menggunakan, dan mendedahkan data peribadi peserta (termasuk namun tidak terhad kepada maklumat yang diberikan oleh peserta dalam borang penyertaan, serta gambar, imej dan video peserta) untuk tujuan kempen, pengiklanan dan publisiti pada masa hadapan berkaitan dengan kempen dalam mana-mana dan semua media tanpa sebarang pampasan, pemberitahuan atau kebenaran tambahan.</li>
                            <li>Penganjur sekutu dan/atau syarikat berkaitan tidak akan bertanggungjawab ke atas sebarang kehilangan, kerosakan, atau kecederaan peribadi yang dialami oleh peserta dalam proses menyertai peraduan seperti yang dibenarkan oleh undang-undang. Jumlah dan liabiliti agregat Penganjur sekutu dan/atau syarikat berkaitan kepada Peserta termasuk dan tidak terhad kepada sebarang tuntutan yang timbul daripada atau berkaitan dengan terma dan syarat ini, bagi pelanggaran kewajipan berkanun, sebarang bentuk kerugian, kerosakan atau kecederaan diri tidak boleh melebihi jumlah RM100 bagi setiap Peserta.</li>
                        </ul>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col s12">
                        <h1 class="terma-title">How To Participate</h1>

                        <h3 class="terma-subtitle">Who can Join the Contest?</h3>
                        <p>The campaign is open to all eligible customers who register for Tefal’s e-Warranty through the Club Tefal portal and approved from 1 APRIL – 31 MAY 2022.</p>

                        <h3 class="terma-subtitle">Who is Eligible?</h3>
                        <p>All customers residing in Malaysia with a valid Malaysian address who have purchased Tefal products from Groupe SEB Malaysia Sdn. Bhd. or its authorised dealers in Malaysia during the campaign period.</p>

                        <h3 class="terma-subtitle">Who is Not Eligible?</h3>
                        <p>Employees of Groupe SEB Malaysia Sdn. Bhd. (including companies in association with and related to Groupe SEB Malaysia Sdn. Bhd.), their immediate family members (including children, parents, brothers and sisters, including spouses), representatives, employees, servants and/or agents of advertising, and/or promotion service providers, and/or resellers, dealers, distributors of Groupe SEB Malaysia Sdn. Bhd. (including companies in association with and related to Groupe SEB Malaysia Sdn. Bhd.), and their immediate family members (including children, parents, brothers and sisters, including spouses.</p>

                        <h3 class="terma-subtitle">How to Participate?</h3>
                        <p>Please follow all the steps on how to join the campaign as well as on how to claim prize item(s) during the campaign period</p>
                        <ul class="browser-default">
                            <li>Purchase any Tefal products during the campaign period.</li>
                            <li>Keep your proof of purchase.</li>
                            <li>Go to <a href="https://clubtefal.com.my">https://clubtefal.com.my/.</a></li>
                            <li>Log in to your existing account / Register new account.</li>
                            <li>Register and submit your NEW e-Warranty.</li>
                            <li>Admin approval and update will take between 3-5 days, which can be viewed on the ‘View Warranty’ page of <a href="https://clubtefal.com.my">https://clubtefal.com.my/</a></li>
                            <li>Go to the campaign tab titled “Raya 2022” to get redirected to the campaign page upon successful approval of your e-Warranty. You will only be notified of approved e-Warranty during the campaign period.</li>
                            <li>Check awarded sticker(s).</li>
                            <li>Collect sticker(s) to redeem desired prize item(s).</li>
                            <li>For every redemption, the respective no. of sticker(s) will be used, and the sticker counter will reset back at 0.</li>
                            <li>You may also opt to donate existing sticker(s) to the campaign’s appointed charity organization.</li>
                            <li>An appreciation email will be sent upon the successful confirmation of the redeemed prize item(s) and submission of your personal details.</li>
                            <li>Your prize item(s) will be delivered within 4-6 weeks of the mailing of the appreciation email.</li>
                        </ul>

                        <p style="font-style: italic">All submissions of e-Warranties must be new and previously unsubmitted. All submissions that are made before and/or after the campaign period are not counted as valid submissions.</p>
                        <p style="font-style: italic">*Each prize item is subject to its limitation in quantity.</p>
                        <p style="font-style: italic">*Redemption is based on first come first serve basis. While stocks last.</p>
                        <p style="font-style: italic">*RM 100 in RRP value of product purchased = 1 sticker.</p>
                        <p style="font-style: italic">*Tefal will announce the total collection of sticker(s), converted to monetary and/or product(s), collaborative brands’ good(s) value, which will be donated to campaign’s appointed charity organization.</p>

                        <h1 class="terma-title">Terms & Conditions</h1>
                        <ul class="browser-default">
                            <li>The campaign is organised by Groupe SEB Malaysia Sdn. Bhd. and will run from 1 APR to 31 MAY 2022 (both dates inclusive) (the "Campaign Period").</li>
                            <li>All decisions made in relation to the campaign including the decisions in determining the winners and prizes will be at the sole discretion of Groupe SEB Malaysia Sdn. Bhd. and no further correspondence, attempts to, or request to appeal, review, or dispute of such decisions will be entertained.</li>
                            <li>Received products awarded by Groupe SEB Malaysia Sdn. Bhd. are not transferable to any third party, nor are they exchangeable for cash and/or other treatments and services.</li>
                            <li>Completed process of awarded prize(s) CANNOT be revoked, cancelled, returned, or exchanged for any reason whatsoever.</li>
                            <li>Groupe SEB Malaysia Sdn. Bhd. gives no guarantee on the quality of the item(s) or their suitability for any purpose.</li>
                            <li>Please allow 4-6 weeks for delivery of the prize item(s) from the mailing of the appreciation email.</li>
                            <li>No delivery will be made to P.O.Box addresses as well as addresses outside Malaysia.</li>
                            <li>If the member does not receive the prize item(s) after fourteen (14) business days from the date of the delivery notification, it will be the member’s responsibility to inform Groupe SEB Malaysia Sdn. Bhd. on the non-receipt of the prize item(s). If no query is received by the eighteenth (18th) business day from the delivery notification, the prize item(s) will be considered received and accepted in good order by the member.</li>
                            <li>All prizes must be claimed within the stipulated time frame indicated in the Terms & Conditions of the campaign numbered 21. Any unclaimed prizes shall be forfeited and Groupe SEB Malaysia Sdn. Bhd. will not compensate or be held liable for failure to claim the prize(s). Any appeal will not be entertained. Any entries submitted after closing date of the campaign will not be entertained.</li>
                            <li>If the choice of prize item(s) is/are unavailable with the reasons being the prize item(s) is/are temporarily out of stock or discontinued, Groupe SEB Malaysia Sdn. Bhd. has the right to replace the prizes with item(s) of a similar value after notifying the member.</li>
                            <li>By participating in this campaign, the participant is deemed to have read, understood, and agreed to be bound by the Terms and Conditions stated herein. The participants hereby authorise and consent to the use of the names and/ or photographs taken of and by the participants by the Organiser as materials for the purpose of advertising, trade and/ or publicity, without prior notice to the participants and the participants shall not be entitled to claim ownership and /or other forms of compensation.</li>
                            <li>Any decision made by Groupe SEB Malaysia Sdn. Bhd. shall be final and binding and no correspondence in terms of verbal or written will be entertained.</li>
                            <li>Groupe SEB Malaysia Sdn. Bhd. reserves the right, at any time to add, delete, or amend the Terms & Conditions herein or change or modify any respect of this campaign, in whole or in part anytime and from time to time and at its sole discretion without notice and without liability to any participant or any other party.</li>
                            <li>This campaign is in no way sponsored, endorsed, or administered by, or associated with any other social Network, search engines and etc. Participants are providing information to Groupe SEB Malaysia Sdn. Bhd. and not to any other party.</li>
                            <li>The Participants by participating in this campaign hereby agrees to the terms and conditions of the Organiser’s Privacy Notice listed at https://www.tefal.com.my/privacy which shall include and not limited to the participant’s consent for to process, use, and disclose the participant’s personal data (including but not limited to the information provided by the participant in the entry form, as well as the participant’s photographs, images, and videos) for purposes of the campaign, and future advertising and publicity in connection with the campaign in any and all media without any additional compensation, notification, or permission.</li>
                            <li>The Organiser its affiliates and/or related companies will not be liable for any loss, damage, or personal injury incurred by the contestants in the process of joining the contest to the extent as may be permitted by law. The total and aggregate liability of the Organiser its affiliates and/or related companies to the Participants including and not limited to any claims arising out of or in connection with this terms and conditions, for breach of statutory duty, any form of loss, damage or personal injury shall not exceed the amount of RM100 per Participant.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Raya2022Component",
    props: [
        'siteUrl',
        'userId',
        'warrantyUrl',
        'getProductsUrl',
        'getUserUrl',
        'getStickersUrl',
        'postCampaignDataUrl',
        'postCampaignDonateUrl',
        'getRedeemProductsUrl'
    ],
    data () {
        return {
            products: [],
            email: '',
            name: '',
            phone_no: '',
            address: '',
            is_agree_term: false,
            stickers: 0,
            is_success_submit: false,
            chosen_product: '',
            donate_stickers: 0,
            is_agree_donate: false,
            is_success_donate: false,
            is_loading: false,
            redeem_lists:[]
        }
    },
    computed : {
        is_allow_donate() {
            if (this.donate_stickers > 0) {
                if (this.donate_stickers <= this.stickers && this.is_agree_donate) {
                    return true
                }
                else {
                    return false
                }
            } else {
                return false
            }
        },
        is_allow_submit() {
            if (this.name && this.email && this.phone_no && this.address && this.is_agree_term) {
                return true
            } else {
                return false
            }
        },
    },
    created() {
        $(document).ready(function() {
            $('#select-prize-modal').modal();
            $('#error-modal').modal();
            $('#terma-modal').modal();
            $('#redeem-modal').modal();
        })
    },
    mounted () {
        this.getProducts()
        this.getRedeemProducts()

        if (this.userId > 0)
        {
            this.getUser();
            this.getStickers()
        }
    },
    methods: {
        incrementSticker() {
            if (this.stickers > this.donate_stickers)
            {
                this.donate_stickers++
            }

        },
        decrementSticker() {
            if (this.donate_stickers >= 1)
            {
                this.donate_stickers--
            }

        },
        openRedeemModal() {
            $('#redeem-modal').modal('open');
        },
        getStickers() {
            axios.get(this.getStickersUrl, {
                params: {
                    user_id: this.userId
                }
            }).then((response) => {
                // handle success
                this.stickers = response.data.stickers
            })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });
        },
        getRedeemProducts() {
            axios.get(this.getRedeemProductsUrl)
                .then((response) => {
                // handle success
                if (response.data.success === true)
                {
                    this.redeem_lists = response.data.redeems
                }
                else {

                }
            })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });
        },
        getUser () {
            axios.get(this.getUserUrl, {
                params: {
                    id: this.userId
                }
            }).then((response) => {
                    // handle success
                    if (response.data.user)
                    {
                        console.log(response.data.user)
                        this.email = response.data.user.email
                        this.phone_no = response.data.user.phone_no
                        this.name = response.data.user.name
                        this.address = response.data.user.complete_address
                    }
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });
        },
        getProducts () {
            axios.get(this.getProductsUrl)
                .then((response) => {
                    // handle success
                    if (response.data.success === true)
                    {
                        this.products = response.data.products

                        this.products.forEach((product) => {
                            this.$set(product, 'is_active', false)
                            this.$set(product, 'is_submit_again', false)
                        })

                        console.log(this.products);
                    }
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });
        },
        selectPrize (product) {

            if (this.userId > 0)
            {
                if (this.stickers >= product.sticker_need)
                {
                    $('body').css('overflow', 'auto');
                    $('#select-prize-modal').modal('open');
                    this.chosen_product = product
                }
                else
                {
                    $('body').css('overflow', 'auto');
                    $('#error-modal').modal('open');
                }
            }
            else {
                $('body').css('overflow', 'auto');
                $('#select-prize-modal').modal('open');
            }
        },
        openDonate () {
            $('#donate-modal').modal('open');
        },
        closeModal () {
            this.is_success_submit = false
            this.is_success_donate = false

            $('#select-prize-modal').modal('close');
            $('#error-modal').modal('close');
            $('#donate-modal').modal('close');
            $('#redeem-modal').modal('close');
        },
        submitData (product) {
            this.is_loading = true;

            axios.post(this.postCampaignDataUrl, {
                user_id: this.userId,
                product_id: product.id,
                email : this.email,
                name: this.name,
                phone_no: this.phone_no,
                address: this.address,
                stickers: this.stickers,

            }).then((response) => {
                    if (response.data.success) {

                        this.is_success_submit = true
                        this.getStickers()

                        this.products.forEach((original_product) => {
                            if (original_product.id === product.id)
                            {
                                original_product.is_active = true
                                original_product.is_submit_again = true
                            }
                        })

                        this.is_loading = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        submitDonate () {
            this.is_loading = true;

            if (this.donate_stickers > 0)
            {
                axios.post(this.postCampaignDonateUrl, {
                    user_id: this.userId,
                    donate_stickers: this.donate_stickers

                }).then((response) => {
                    if (response.data.success) {
                        this.is_success_donate = true
                        this.getStickers()

                        this.is_loading = false;
                    }
                })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            else {
                this.is_loading = false;
            }
        },
        openTermaModal()
        {
            $('#terma-modal').modal('open');
        }
    }
}
</script>

<style lang="scss" scoped>
/* CSS MEDIA LAYOUT CROSS ALL DEVICES (MATERIALIZE CSS) */
    .long-jpeg-container {
        padding: 0;
        position: relative;

        .logo-col {
            position: absolute;
            top: 10%;

            img {
                margin: 0 auto;
                display: block;
            }
        }
    }

    .semak-hadiah {
        font-size: 24px;
        font-weight: bold;
        color: #f8cf95;
        text-decoration: underline;
    }

    .up-down {
        vertical-align: top;

        .arrow-col {
            cursor: pointer;
            padding: 10px;
            background-color: #f8cf95;
            margin-bottom: 4px;
            display: inline-block;
        }
    }

    .promosi-title {
        color: #f7cf96;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;

        span {
            font-size: 26px;
        }
    }
    .langkah-title {
        color: #f7cf96;
        text-align: center;
        font-weight: bold;
        font-size: 2.2rem;
        margin-top: 0.65rem;
        margin-bottom: 0.65rem;
    }

    .langkah-description {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
        text-align: center;
    }

    img {
        margin: 0 auto;
        display: block;
    }

    .title-cont {
        top: -15rem;
        position: relative;
    }

    h1.title {
        color: #f7cf96;
        text-align: center;
        font-weight: bold;
        font-size: 2.5rem;
        line-height: 3rem;
    }

    .stiker-total-title {
        text-align: center;
        font-weight: bold;
        font-size: 2rem
    }

    .sticker-total-cont {
        background-color: #f8cf95;
        color: #2d4534;
        margin-top: 25px;
        border-radius: 30px;
        padding-top: 0.65rem;
        padding-bottom: 0.65rem;
    }

    .derma-main-row {
    }

    .promosi-main-row {
        width: 40%;
        margin-bottom: 0;
        margin-top: 5%;
    }

    .derma-title {
        color: #f7cf96;
        font-weight: bold;
        font-size: 21px;
        line-height: 24px;
        margin-bottom: 10px;
    }

    .derma-cont {
        //padding: 15px;
    }

    .derma-btn {
        width: 100%;
        font-weight: bold;
        font-size: 24px;
    }

    .product-col {
        background-color: #426852;
        border: 3px solid #b77c2d;
        position: relative;

        .product-inner-col {
            padding-top: 3rem;
            padding-bottom: 3rem;

            .product-sticker {
                color: #f7cf96;
                text-align: center;
                font-weight: bold;
                font-size: 2.2rem;
                text-transform: uppercase;
            }

            .product-name {
                color: #fff;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 5px;
            }
            .tebus-btn {
                margin-bottom: 25px;
            }
        }
    }

    .term-title {
        color: #f7cf96;
    }

    #terma-modal {
        h1.terma-title {
            font-size: 28px;
            font-weight: bold;
            color: #d33;
            text-transform: uppercase;
        }

        .terma-subtitle {
            font-size: 18px;
            font-weight: bold;
        }
    }

    #select-prize-modal, #error-modal, #donate-modal, #redeem-modal {
        background-color: #426852;
        border: 3px solid #b77c2d;

        .modal-content {
            margin-left: 3rem;
            margin-right: 3rem;

            .product-name {
                color: #fff;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 5px;
            }

            .form-control {
                border: 2px solid #F3D097;
                margin-bottom: 15px;
                text-align: center;
                color: #F3D097;

                &::placeholder {
                    color: #F3D097;
                    text-align: center;
                }
            }

            textarea {
                height: auto;
            }

            .penghantaran-col {
                border: 2px solid #F3D097;
            }

            .penghantaran-title {
                text-align: center;
                color: #F3D097;
                font-size: 16px;
                font-weight: bold;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }

            .modal-message {
                font-size: 20px;
                color: #F3D097;
                font-weight: bold;
            }

            .action-btn {
                font-weight: bold;
                font-size: 24px;
            }
        }

    }

    #redeem-modal {
        overflow-y: hidden;
        .redeem-inner-col {
            overflow-y: auto;
            display: block;
            height: 500px;
            color: #fff;
        }
    }

    [type=checkbox].filled-in:not(:checked) + span:not(.lever):after {
        border: 2px solid #F3D097;
    }

    [type=checkbox] + span:not(.lever) {
        color: #F3D097;
    }

    .product-img-cont {
        height: 180px;

        .product-img {
            object-fit: contain;
            height: 100%;
            width: 100%;
        }
    }

    #donate-modal {
        .number-donate-input {
            display: inline-block;
            width: 80%;
        }
    }

    a {
        color: #f8cf95;
        text-decoration: underline;
    }

    /* Monitor Screen */
    @media only screen and (min-width: 1441px)
    {

    }

    /*Laptop screen with and without retina display */
    @media only screen and (min-width: 1201px) and (max-width: 1440px)
    {

    }

    /* Tablet Landscape or bigger portrait tablet such as Ipad Pro */
    @media only screen and (min-width: 993px) and (max-width: 1200px)
    {
        .title-cont {
            top: -5rem;
            position: relative;

            .title-gif {
                width: 65%;
            }
        }

        h1.title {
            font-size: 2rem;
            line-height: 2.5rem;
        }

        .langkah-title {
            font-size: 1.8rem;
        }

        .langkah-description {
            font-size: 16px;
            line-height: 20px;
        }

        .langkah-img {
            width: 80%;
        }

        .derma-main-row {
            //width: 50%;
        }

        #select-prize-modal, #error-modal, #donate-modal, #redeem-modal {
            width: 90%;
        }

        .product-col {
            .product-inner-col {
                .product-sticker {
                    font-size: 1.8rem;
                }

                .product-name {
                    font-size: 16px;
                }
                .tebus-btn {

                }
            }
        }

        /*media deal with longer tablet screen such as Ipad Pro */
        @media only screen and (min-height: 1024px) {

        }
    }

    /* Tablet Portrait */
    @media only screen and (max-width: 992px) and (min-height: 480px)
    {
        .title-cont {
            top: -5rem;
            position: relative;

            .title-gif {
                width: 80%;
            }
        }

        h1.title {
            font-size: 1.8rem;
            line-height: 2.2rem;
        }

        .langkah-title {
            font-size: 1.8rem;
        }

        .langkah-description {
            font-size: 16px;
            line-height: 20px;
        }

        .langkah-img {
            width: 80%;
        }

        .derma-main-row {
            //width: 70%;
        }

        #select-prize-modal, #error-modal, #donate-modal, #redeem-modal {
            width: 90%;

            .modal-img {
                width: 40%;
            }
        }

        .product-col {
            .product-inner-col {
                .product-sticker {
                    font-size: 1.8rem;
                }

                .product-name {
                    font-size: 16px;
                }
                .tebus-btn {

                }
            }
        }

        .product-img-cont {
            height: 180px;

            .product-img {
                object-fit: contain;
                height: 100%;
                width: 100%;
            }
        }

        .promosi-main-row {
            width: auto;
        }

        .promosi-title {
            font-size: 16px;
        }
    }

    /* Phone Portrait */
    @media only screen and (max-width: 600px)
    and (orientation: portrait)
    {
        .logo-col {
            img {
                width: 30%;
            }
        }

        .title-cont {
            top: -3rem;
            .title-gif {
                width: 100%;
            }
        }

        h1.title {
            font-size: 1.4rem;
            line-height: 1.6rem;
        }

        .langkah-img {
            width: 65%;
        }

        .langkah-title {
            margin-top: 0;
            margin-bottom: 0;
        }

        .langkah-description {
            margin-bottom: 25px;
        }

        .stiker-tottal-title {
            font-size: 1.6rem;
        }

        .derma-main-row {
           // width: 100%;
        }

        .derma-title {
            font-size: 16px;
            line-height: 20px;
        }

        .product-col {
            .product-inner-col {
                .product-sticker {
                    font-size: 1.5rem;
                }

                .product-name {
                    font-size: 14px;
                }
                .tebus-btn {

                }
            }
        }

        .product-img-cont {
            height: 165px;
        }

        #select-prize-modal, #error-modal, #donate-modal, #redeem-modal {
            .modal-content {
                margin-left: 0;
                margin-right: 0;

                .modal-message {
                    font-size: 16px;
                }

                .penghantaran-title {
                    font-size: 14px;
                }
            }

            img {
                width: 20%;
                display: none;
            }
        }

        #redeem-modal {
            overflow-y: hidden;
            overflow-x: hidden;

            .redeem-inner-col {
                overflow-y: auto !important;
                height: 400px;
            }
        }

        .semak-hadiah {
            font-size: 16px;
        }

        #donate-modal {
            .number-donate-input {
                display: inline-block;
                width: 50%;
            }
        }
        .stiker-total-title {
            font-size: 1.2rem;
        }
        /* media for the shorter phone screen such as Iphone 4*/
        @media only screen and (max-height: 480px) {

        }

        /* media for the shorter phone screen such as Iphone 4 AND some some unusual small screen that never exist */
        @media only screen and (max-height: 400px) {

        }

        /* media for the longer phone screen */
        @media only screen and (min-height: 650px) {

        }

    }
</style>
